import Link from 'root/src/client/web/base/Link';
import { settingsRowClass, SettingsRowInner } from './SettingsRow';
// Navigation row to an existing route (whole pages live outside the settings modal). Accepts either
// a routeId (routed Link) or a direct href (plain anchor, the redesign-page convention).
export const SettingsLinkRow = ({ label, description, routeId, href, Icon }) => {
    const isLink = Boolean(href || routeId);
    const row = (<div className={settingsRowClass}>
			<SettingsRowInner label={label} description={description} Icon={Icon} isLink={isLink}/>
		</div>);
    if (href) {
        return (<a href={href} className="block no-underline">
				{row}
			</a>);
    }
    if (routeId) {
        return (<Link routeId={routeId} className="block no-underline">
				{row}
			</Link>);
    }
    return row;
};
